import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

// services
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { AppState } from '../models/app-state.interface';
import { EventsService } from '../services/events.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {

  constructor(
    private _errorService: ErrorHandler,
    private _eventsService: EventsService,
    private _appStore: Store<AppState>,
  ) { }

  validateBookingSections(currentBooking) {
    const bookingProductType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingProduct;
    const penalType = bookingProductType === 'abc' ? 'collection' : 'delivery'
    if (
      !currentBooking.bookingCompletion.deliveryLocationDetail ||
      currentBooking.bookingJourney[0].deliveryLocation.addressPostCode === ''
    ) {

      const errorData = {
        text: "There seems to have been an error with your delivery location. You'll be redirected back to the relevant section.",
        sticky: false
      };

      this._errorService.handleCustomError(errorData);
      // check product type
      setTimeout(() => {
        this._eventsService.goToPanelByPath(penalType + '-location');
      }, 3500);

      return false;

    } else if (
      !currentBooking.bookingCompletion.deliveryDateTimeDetails ||
      currentBooking.bookingJourney[0].deliveryDateTimeUTC === ''
    ) {

      const errorData = {
        text: "There seems to have been an error with your delivery time. You'll be redirected back to the relevant section.",
        sticky: false
      };

      this._errorService.handleCustomError(errorData);
      // check product type
      setTimeout(() => {
        this._eventsService.goToPanelByPath(penalType + '-location');
      }, 3500);

      return false;

    } else if (
      !currentBooking.bookingCompletion.collectionLocationDetails ||
      currentBooking.bookingJourney[0].collectionLocation.addressPostCode === ''
    ) {

      const errorData = {
        text: "There seems to have been an error with your collection location. You'll be redirected back to the relevant section.",
        sticky: false
      };

      this._errorService.handleCustomError(errorData);
      // check product type
      setTimeout(() => {
        this._eventsService.goToPanelByPath(penalType + '-location');
      }, 3500);

      return false;

    } else if (
      !currentBooking.bookingCompletion.collectionDateTimeDetails ||
      currentBooking.bookingJourney[0].collectionDateTimeUTC === ''
    ) {

      const errorData = {
        text: `There seems to have been an error with your %s time. You'll be redirected back to the relevant section.`,
        sticky: false
      };

      this._errorService.handleCustomError(errorData, true, [penalType]);
      // check product type
      setTimeout(() => {
        this._eventsService.goToPanelByPath(penalType + '-time');
      }, 3500);

      return false;
    }

    return true;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }
}
